<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <query-tag-input
          :label="$t(`${baseTrad}.produit`)"
          v-model="critereRecherche.produitAchatIds"
          icon="magnify"
          autocomplete
          field="reference"
          :query="(search) => func.getAllProduits({
            query: {
              auto: search,
              societeId: societeActiveId,
              sens: constantes.SENS_ACHAT,
              categorie: [constantes.CATEGORIE_IMPRESSION_AFFICHE],
            }
          })">
          <template #default="{ option }">
            {{ option.reference }} - {{ option.libelle }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          v-model="critereRecherche.formatAfficheIds"
          :label="$t(`${baseTrad}.formatAffiche`)"
          :items="formatAffiches"
          field="libelle">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          v-model="critereRecherche.natureSupportAfficheIds"
          :label="$t(`${baseTrad}.natureSupport`)"
          :items="natureSupports"
          field="libelle">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          v-model="critereRecherche.typeMaterielIds"
          :label="$t(`${baseTrad}.materielType`)"
          :items="materielTypes"
          field="libelle">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-fournisseur-tag-input
          v-model="critereRecherche.tiersDestinataireIds"
          :label="$t(`${baseTrad}.tiersDestinataire`)"
          :societeActiveId="societeActiveId"
          :sousType="constantes.SOUS_TYPES">
        </query-fournisseur-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-fournisseur-tag-input
          v-model="critereRecherche.lieuLivraisonPrestationIds"
          :label="$t(`${baseTrad}.lieuLivraisonPrestation`)"
          :societeActiveId="societeActiveId"
          :sousType="[constantes.TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON]">
        </query-fournisseur-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <input-periode
          v-model="critereRecherche.dateLivraison"
          :label="$t(`${baseTrad}.dateLivraison`)"
          orientation= 'top'>
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t(`${baseTrad}.commandeAchat`)">
          <qd-taginput
            v-model="critereRecherche.codesCommandeAchat"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t(`${baseTrad}.commande`)">
          <b-select v-model="critereRecherche.commande">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }} </option>
            <option :value="false"> {{ $t('general.non') }} </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { getAll as getAllProduits } from '@/api/produit/index';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/bodac/besoin/genererCritereRecherche';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CRITERE } from '@/store/modules/bodac/besoin/besoin-mutation-type';
import { COMMANDE_ACHAT_FOURNISSEUR_ETAT, LISTE_TYPE_DEVIS_COMMANDE, SENS_ACHAT } from '@/configuration/devisConf';
import {
  CATEGORIE_IMPRESSION_AFFICHE,
} from '@/configuration/catalogue/produitConf';
import {
  TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
  LISTE_SOUS_TYPE_FOURNISSEURS_PAGES,
} from '@/configuration/tiers/tiersConf';
import InputPeriode from '@/components/general/inputPeriode';
import QueryTagInput from '@/components/general/tagInput/queryTagInput';
import LibelleTagInput from '@/components/general/tagInput/libelleTagInput';
import QueryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'FiltreListeBesoin',
  props: {
    nameStore: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      baseTrad: 'editionCommande.logistiqueImpression.affiches.filtre',
      critereRecherche: null,
      func: { getAllProduits },
      constantes: {
        SENS_ACHAT,
        LISTE_TYPE_DEVIS_COMMANDE,
        CATEGORIE_IMPRESSION_AFFICHE,
        COMMANDE_ACHAT_FOURNISSEUR_ETAT,
        TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
        SOUS_TYPES: LISTE_SOUS_TYPE_FOURNISSEURS_PAGES.map(s => s.code),
      },
    };
  },
  components: {
    InputPeriode,
    QueryTagInput,
    LibelleTagInput,
    QueryFournisseurTagInput,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    critereRechercheFromStore() {
      return this.$store.getters[`${this.nameStore}/criteresRecherche`];
    },
    formatAffiches() {
      return this.parametre(PARAMETRES_KEYS.formatAffiche);
    },
    natureSupports() {
      return this.parametre(PARAMETRES_KEYS.natureSupportAffiche);
    },
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    setCritereRecherche(val) {
      this.$store.commit(`${this.nameStore}/${SET_CRITERE}`, val);
    },
    viderCritere() {
      this.critereRecherche = genererCritereRecherche();
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([
          PARAMETRES_KEYS.formatAffiche,
          PARAMETRES_KEYS.natureSupportAffiche,
          PARAMETRES_KEYS.materielType,
        ]);
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
